import { ListItemText, LinearProgress } from '@mui/material';
import styled from 'styled-components';

interface ProgressBarStyleProps {
  backgroundColor: string;
}

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-top: 24px;
`;

export const ItemText = styled(ListItemText)`
  width: 100%;
  display: flex;
  flex-direction: row;

  &:hover {
    background-color: #eeeeee;
  }

  & > span,
  & > p {
    cursor: default;
    padding: 8px 16px;
    width: 50%;
  }
`;

export const ProgressBarStatusText = styled.p`
  margin-top: 8px;
  text-align: center;
  color: #757575;
`;

export const ProgressBar = styled(LinearProgress)<ProgressBarStyleProps>`
  .MuiLinearProgress-bar1Determinate {
    background-color: ${({ backgroundColor }) => backgroundColor};
  }
`;

export const CurvaLactacaoContainer = styled.div`
  padding: 16px;
`;

export const LactacoesLegendContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 10px;
`;

export const LactacoesLegendText = styled.p`
  color: rgba(0, 0, 0, 0.87);
  font-size: 14px;
`;
